import React from 'react';
import { ICustomizableElement, ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SubsectionTitleStyled } from './styles';

export interface SubsectionTitleProps extends ICustomizableElement, ITestingElement {
  text: React.ReactNode;
}

const SubsectionTitle: React.FC<SubsectionTitleProps> = ({ text, className, 'data-test-id': dataTestId }) => {
  return (
    <SubsectionTitleStyled className={className} data-test-id={dataTestId}>
      {text}
    </SubsectionTitleStyled>
  );
};

export default SubsectionTitle;
